import * as types from "./../../statics/actionConstants";
import { createReducer } from "@reduxjs/toolkit";

const API = createReducer([], {
  [types.API_DRAFT]: (state, action) => {
    state.Message = action.Draft;
  },
  [types.API_MESSAGE]: (state, action) => {
    state.Message = action.Message;
  },
  [types.API_MESSAGE_BODY]: (state, action) => {
    state.Message.body = action.MessageBody;
  },
  [types.API_MESSAGE_SUBJECT_CATEGORY]: (state, action) => {
    let subject = action.MessageSubjectCategory[0];
    let category = action.MessageSubjectCategory[1];
    state.Message = { ...state.Message, subject, category };
  },
  [types.API_MESSAGES_RECEIVED]: (state, action) => {
    state.MessagesReceived = action.MessagesReceived;
  },
  [types.API_MESSAGES]: (state, action) => {
    state.Messages = action.Messages;
  },
  [types.API_EMPLOYEE]: (state, action) => {
    state.Employee = action.Employee;
  },
  [types.API_MAILBOXES]: (state, action) => {
    state.Mailboxes = action.Mailboxes;
  },
  [types.API_MAILBOX]: (state, action) => {
    state.Mailbox = action.Mailbox;
  }
});

export default API;
